module.exports = __webpack_public_path__ + "media/src/assets/Images/Check-beb97fa5f1f49fdea42a7a362f6a73a1.svg";